(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auto-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lookstan-size-dialog'))customElements.define('lookstan-size-dialog',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.openButton=this.querySelector('.ls-guide__open');this.productRoot=this.closest('product-info');const place=()=>{const app=this.productRoot?.querySelector('variant-swatch-king');const native=this.productRoot?.querySelector('variant-selects');const picker=app||native;if(picker&&picker.nextElementSibling!==this){this.moving=true;picker.after(this);this.moving=false;}};place();this.placementObserver=new MutationObserver(place);if(this.productRoot)this.placementObserver.observe(this.productRoot,{childList:true,subtree:true});this.openButton.addEventListener('click',()=>{this.lockPage();this.dialog.showModal();this.querySelector('.ls-guide__body').scrollTop=0;});this.querySelector('.ls-guide__close').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();});this.dialog.addEventListener('close',()=>{this.unlockPage();this.openButton.focus({preventScroll:true});});this.querySelector('.ls-guide__zoom')?.addEventListener('click',event=>{const active=event.currentTarget.getAttribute('aria-pressed')!=='true';event.currentTarget.setAttribute('aria-pressed',String(active));event.currentTarget.textContent=active?event.currentTarget.dataset.out:event.currentTarget.dataset.in;this.querySelector('.auto-size-guide-inline__image-wrap')?.classList.toggle('is-zoomed',active);});}
lockPage(){
if(this.locked)return;this.locked=true;this.scrollPosition=window.scrollY;
this.bodyStyles={};for(const key of ['position','top','left','right','width','overflow'])this.bodyStyles[key]=document.body.style[key];
this.htmlOverflow=document.documentElement.style.overflow;this.htmlScrollBehavior=document.documentElement.style.scrollBehavior;
document.documentElement.style.overflow='hidden';document.documentElement.style.scrollBehavior='auto';
Object.assign(document.body.style,{position:'fixed',top:('-'+this.scrollPosition+'px'),left:'0',right:'0',width:'100%',overflow:'hidden'});
}
unlockPage(){if(!this.locked)return;this.locked=false;Object.assign(document.body.style,this.bodyStyles);document.documentElement.style.overflow=this.htmlOverflow;window.scrollTo(0,this.scrollPosition);document.documentElement.style.scrollBehavior=this.htmlScrollBehavior;}
disconnectedCallback(){if(this.moving)return;this.placementObserver?.disconnect();this.unlockPage();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-interface-icons"] && !Shopify.designMode) return;
  try {
    (() => {
const pattern=/(?:\p{Regional_Indicator}{2}|\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})?(?:\u200D\p{Extended_Pictographic}(?:\uFE0F|\p{Emoji_Modifier})?)*|[↗→])/gu;
const paths={arrow:'M5 12h14m-5-5 5 5-5 5',diagonal:'M6 18 18 6M6 6h12v12',gift:'M3 8h18v4H3zM5 12v9h14v-9M12 8v13M12 8C3 8 5 1 9 3c2 1 3 5 3 5Zm0 0c9 0 7-7 3-5-2 1-3 5-3 5Z',check:'m5 12 4 4L19 6',heart:'M12 20 4 12C-2 5 7 0 12 7c5-7 14-2 8 5Z',star:'m12 3 3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1Z',globe:'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM3 12h18M12 3c-5 5-5 13 0 18 5-5 5-13 0-18Z',truck:'M2 5h12v12H2ZM14 10h4l4 4v3h-8M8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm12 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z'};
function icon(token){const type=token==='↗'?'diagonal':token==='→'?'arrow':/🎁/.test(token)?'gift':/✅|✔|☑/.test(token)?'check':/❤|💗|💖/.test(token)?'heart':/🚚|🚛/.test(token)?'truck':/\p{Regional_Indicator}/u.test(token)?'globe':'star';const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('width','16');svg.setAttribute('height','16');svg.setAttribute('fill','none');svg.setAttribute('stroke','currentColor');svg.setAttribute('stroke-width','1.5');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');svg.style.cssText='display:inline-block;vertical-align:-.15em;flex-shrink:0;margin-inline:.15em';const p=document.createElementNS(svg.namespaceURI,'path');p.setAttribute('d',paths[type]);svg.append(p);return svg;}
function convert(root){const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);const nodes=[];while(walker.nextNode()){const n=walker.currentNode;if(n.parentElement?.closest('script,style,textarea,input,select,svg,iframe,[contenteditable]'))continue;pattern.lastIndex=0;if(pattern.test(n.textContent))nodes.push(n);}for(const n of nodes){const text=n.textContent;pattern.lastIndex=0;const fragment=document.createDocumentFragment();let index=0;for(const match of text.matchAll(pattern)){fragment.append(document.createTextNode(text.slice(index,match.index)),icon(match[0]));index=match.index+match[0].length;}fragment.append(document.createTextNode(text.slice(index)));n.replaceWith(fragment);}}
function start(){convert(document.body);const observer=new MutationObserver(records=>{observer.disconnect();for(const r of records){if(r.type==='characterData'&&r.target.parentElement)convert(r.target.parentElement);else for(const n of r.addedNodes)if(n.nodeType===1)convert(n);else if(n.nodeType===3&&n.parentElement)convert(n.parentElement);}observe();});const observe=()=>observer.observe(document.body,{childList:true,subtree:true,characterData:true});observe();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-my-size"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lookstan-my-size')) {
    customElements.define('lookstan-my-size', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.key = 'lookstan.preferred-size.v1';
        this.param = 'filter.v.option.size';
        this.select = this.querySelector('select');
        this.clear = this.querySelector('button');
        this.groups = new Map();
        const normalize = value => value.replace(/\s*\([^)]*(?:kg|كجم)[^)]*\)/ig, '').trim().replace(/^2XL$/i, 'XXL');
        let values = [];
        try { values = JSON.parse(this.querySelector('script').textContent); } catch { return; }
        values.forEach(value => { const name = normalize(value); if (!this.groups.has(name)) this.groups.set(name, []); this.groups.get(name).push(value); });
        if (!this.groups.size) return;
        const order = ['XXS','XS','S','M','L','XL','XXL','3XL','4XL'];
        [...this.groups.keys()].sort((a,b) => {
          const ai = order.indexOf(a), bi = order.indexOf(b);
          return ai >= 0 && bi >= 0 ? ai-bi : ai >= 0 ? -1 : bi >= 0 ? 1 : a.localeCompare(b, undefined, {numeric:true});
        }).forEach(name => this.select.add(new Option(name, name)));
        let saved = '';
        try { saved = localStorage.getItem(this.key) || ''; } catch {}
        this.saved = this.groups.has(saved) ? saved : '';
        const explicit = new URL(location.href).searchParams.getAll(this.param).map(normalize);
        if (explicit.length && explicit.some(value => value !== this.saved)) this.save('');
        this.refresh();
        this.hidden = false;
        this.select.addEventListener('change', () => {
          this.save(this.select.value);
          const url = new URL(location.href);
          if (!this.isListing(url)) { url.pathname = this.dataset.all; url.search = ''; const preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) url.searchParams.set('preview_theme_id', preview); }
          this.apply(url, true);
          location.assign(url.href);
        });
        this.clear.addEventListener('click', () => {
          this.save('');
          const url = new URL(location.href);
          if (this.isListing(url)) { this.apply(url, true); location.assign(url.href); }
        });
        document.addEventListener('input', event => {
          if (event.target.name === this.param) this.save('');
        });
        document.addEventListener('click', event => {
          const link = event.target.closest('a[href]');
          if (!link || !this.saved) return;
          if (link.closest('facet-remove') || link.classList.contains('js-facet-remove')) { this.save(''); return; }
          const url = new URL(link.href, location.href);
          if (url.origin !== location.origin || !this.isListing(url) || url.searchParams.has(this.param)) return;
          this.apply(url);
          link.href = url.href;
        });
        const current = new URL(location.href);
        if (this.saved && this.isListing(current) && !current.searchParams.has(this.param)) {
          this.apply(current);
          location.replace(current.href);
        }
      }
      isListing(url) { return /\/collections\/[^/]+\/?$/.test(url.pathname) || /\/search\/?$/.test(url.pathname); }
      save(value) { this.saved = value; try { if (value) localStorage.setItem(this.key, value); else localStorage.removeItem(this.key); } catch {} this.refresh(); }
      refresh() { this.select.value = this.saved; this.clear.hidden = !this.saved; }
      apply(url, replace = false) {
        if (replace) { url.searchParams.delete(this.param); url.searchParams.delete('page'); }
        if (this.saved) {
          (this.groups.get(this.saved) || []).forEach(value => url.searchParams.append(this.param, value));
          if (!url.searchParams.has('filter.v.availability')) url.searchParams.set('ls_size_stock', '1');
          url.searchParams.set('filter.v.availability', '1');
        } else if (url.searchParams.has('ls_size_stock')) {
          url.searchParams.delete('ls_size_stock'); url.searchParams.delete('filter.v.availability');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-policy-guide"] && !Shopify.designMode) return;
  try {
    const policyContents=document.querySelector('.ls-policy-toc');if(policyContents){const headings=document.querySelectorAll('.shopify-policy__body h2,.shopify-policy__body h3');headings.forEach((heading,index)=>{if(!heading.id)heading.id=`lookstan-policy-heading-${index+1}`;const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;policyContents.querySelector('nav').append(link);});policyContents.hidden=!headings.length;}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-reward-edit"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lookstan-reward-edit')){
  customElements.define('lookstan-reward-edit',class extends HTMLElement{
    connectedCallback(){
      this.querySelector('[data-reward-controls]').hidden=false;
      this.onChoice=event=>{const button=event.target.closest('[data-reward-choice]');if(!button||button.getAttribute('aria-pressed')==='true')return;const goal=button.dataset.rewardChoice;this.querySelectorAll('[data-reward-choice]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));this.querySelectorAll('[data-reward-panel]').forEach(panel=>{panel.hidden=panel.dataset.rewardPanel!==goal;panel.classList.toggle('is-switching',!panel.hidden)});const panel=this.querySelector('[data-reward-panel="'+goal+'"]');this.querySelector('[data-reward-announcement]').textContent=panel.querySelector('h3').textContent+'. '+panel.querySelector('.ls-reward-edit__caption').textContent;};
      this.addEventListener('click',this.onChoice);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onChoice)}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-size-colors"] && !Shopify.designMode) return;
  try {
    const sizeGrid = document.getElementById('MainContent');
if (sizeGrid) {
  const syncSizeLinks = () => {
    sizeGrid.querySelectorAll('[data-lookstan-size-url]:not([data-lookstan-size-url=""])').forEach(card => {
      const url = card.dataset.lookstanSizeUrl;
      const selected = card.querySelector('.ls-size-color[aria-pressed="true"]');
      if (selected) card.dataset.lookstanSizeImage = selected.dataset.sizeImage;
      card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        if (link.getAttribute('href') !== url) link.setAttribute('href', url);
      });
      const image = card.querySelector('.card__media img');
      if (image && card.dataset.lookstanSizeImage) {
        if (image.getAttribute('src') !== card.dataset.lookstanSizeImage) image.setAttribute('src', card.dataset.lookstanSizeImage);
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
      }
    });
  };
  sizeGrid.addEventListener('click', event => {
    const button = event.target.closest('.ls-size-color');
    if (!button) return;
    event.preventDefault();
    const card = button.closest('[data-lookstan-size-url]');
    card.dataset.lookstanSizeUrl = button.dataset.sizeUrl;
    card.dataset.lookstanSizeImage = button.dataset.sizeImage;
    card.querySelectorAll('.ls-size-color').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    card.querySelector('.ls-size-colors__selection').textContent = button.dataset.sizeLabel;
    syncSizeLinks();
  });
  syncSizeLinks();
  new MutationObserver(syncSizeLinks).observe(sizeGrid, {subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'src', 'srcset']});
}
  } catch(e) { console.error(e); }
})();

})();
